import type { ModeColor, ModeConfig } from "@src/types/factory-dashboard";

const GREY: ModeColor = {
  outline: "rgb(138, 143, 152)",
  background: "rgba(138, 143, 152, 0.1)",
};
const YELLOW: ModeColor = {
  outline: "rgb(245, 179, 1)",
  background: "rgba(245, 179, 1, 0.1)",
};
const GREEN: ModeColor = {
  outline: "rgb(32, 178, 107)",
  background: "rgba(32, 178, 107, 0.1)",
};

export const modeMapping = {
  0: { label: "modules.machineOverviewContainer.mode.other", color: GREY },
  1: { label: "modules.machineOverviewContainer.mode.automatic", color: GREEN },
  2: {
    label: "modules.machineOverviewContainer.mode.semiAutomatic",
    color: GREEN,
  },
  3: { label: "modules.machineOverviewContainer.mode.manual", color: YELLOW },
  4: { label: "modules.machineOverviewContainer.mode.setup", color: YELLOW },
  5: {
    label: "modules.machineOverviewContainer.mode.sleep",
    color: GREY,
  },
};

export interface StaticTTMachineData {
  machineName: string;
  job: string;
  targetPartQuantityGoodTotal: string;
  progress: string;
  cycleTime: string;
  timeRemaining: string;
  effectiveness: string;
  lastUpdated: string;
  modeValue: number;
  modeMapping: Partial<Record<number, ModeConfig>>;
}

export const staticIMMACMachinesData: StaticTTMachineData[] = [
  {
    machineName: "IMM KePlast 3015",
    job: "IM_Housing_PA6GF30",
    targetPartQuantityGoodTotal: "859 / 3000",
    progress: "28.6%",
    cycleTime: "11 s",
    timeRemaining: "6,5h",
    effectiveness: "98%",
    lastUpdated: "",
    modeValue: 1,
    modeMapping: modeMapping,
  },
  {
    machineName: "IMM KePlast 1180",
    job: "IM_Housing_ABS9GF30",
    targetPartQuantityGoodTotal: "2001 / 2822",
    progress: "70.1%",
    cycleTime: "11 s",
    timeRemaining: "2,5h",
    effectiveness: "97%",
    lastUpdated: "",
    modeValue: 1,
    modeMapping: modeMapping,
  },
  {
    machineName: "P0P02CP03x_06.37i",
    job: "",
    targetPartQuantityGoodTotal: "",
    progress: "",
    cycleTime: "",
    timeRemaining: "",
    effectiveness: "",
    modeValue: 1,
    modeMapping: modeMapping,
    lastUpdated: "",
  },
];
